module.exports = __webpack_public_path__ + "img/minus-icon-gray.svg";